import type { HTMLAttributes } from "react";
import { cn } from "../cn";

/**
 * A loading placeholder.
 *
 * Sized to the content it stands in for, so the layout does not jump when data
 * arrives — a spinner that collapses into a table is worse than no spinner.
 * The pulse respects prefers-reduced-motion through the token stylesheet.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded-[var(--radius-control)] bg-surface-2", className)}
      {...props}
    />
  );
}
